import React, { useEffect, useState } from "react";
import DocumentVerificationRequest from "../../components/PropertyView/DocumentVerificationRequest";
import RequestPropertyTab from "../../components/PropertyView/RequestPropertyTab";
import RequestDetailsTab from "../../components/PropertyView/RequestDetailsTab";
import RequestRoomTab from "../../components/PropertyView/RequestRoomTab";
import { useLocation } from "react-router-dom";
import FollowUp from "../Property/FollowUp";
import AddDocument from "./AddDocument";
import MmcPayment from "./MmcPayment";

const RequestPropertyView = () => {
  const location = useLocation();
  const [tabs, setTabs] = useState(1);
  const data = location.state
  const value = data?.data?.property_type


  console.log(data, 'datareq')

  // let obj = {
  //   id: data?.data?.id,
  //   ownerId: data?.data?.owner_id,
  //   document_status: data?.data?.document_status,
  //   verification_status: data?.data?.verification_status
  // }
  // console.log('obj', obj)

  const status = data?.data?.verification_status




  return (
    <div className="dashRightView home_section" >
      <div className='d-flex ac-jb'>
        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec ">
          Property Verification View
        </h2>
      </div>
      <div className='d-flex gap-4 mt-3'>
        <h2 onClick={() => { setTabs(1) }} className={`${tabs == 1 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
          Property
        </h2>
        <h2 onClick={() => { setTabs(2) }} className={`${tabs == 2 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
          Details
        </h2>

        {value == 1 && (
          <h2 onClick={() => { setTabs(3) }} className={`${tabs == 3 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
            Rooms
          </h2>
        )}

        {/* {obj.document_status == 0 && (<h2 onClick={() => { setTabs(6) }} className={`${tabs == 6 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
          Document
        </h2>)}

        {obj.document_status == 0 && (<h2 onClick={() => { setTabs(7) }} className={`${tabs == 7 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
          MMC
        </h2>)} */}

        {status == 2 && (<h2 onClick={() => { setTabs(4) }} className={`${tabs == 4 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
          Document Verification
        </h2>)}

        <h2 onClick={() => { setTabs(5) }} className={`${tabs == 5 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
          Follow Ups
        </h2>

      </div>

      {tabs == 1 && (
        <RequestPropertyTab data={data} setTabs={setTabs} />
      )}
      {tabs == 2 && (
        <RequestDetailsTab data={data} setTabs={setTabs} />
      )}
      {tabs == 3 && <RequestRoomTab data={data} setTabs={setTabs} />}
      {tabs == 4 && <DocumentVerificationRequest data={data} setTabs={setTabs} value={value} />}
      {tabs == 5 && <FollowUp data={data} />}
      {/* {tabs == 6 && <AddDocument propertyId={data?.data?.id} setTabs={setTabs} />}
      {tabs == 7 && <MmcPayment data={data} />} */}


    </div>
  );
};
export default RequestPropertyView